import { createRouter, createWebHashHistory } from "vue-router" 
import { getToken } from "../utils/auth"
// import { getRole } from "../utils/permission"

const routes = [
    { path: '/', redirect: "/player/list", requireAdmin: false },
    {
        path: '/player',
        component: ()=>import("../components/LayoutName.vue"),
        children: [
            {
                path: "list",
                name: "playerList",
                component: ()=>import("../pages/HomePage.vue"),
                meta: { requiresAuth: true, requireAdmin: false }
            }
        ]
    },
    { path: '/user/login', name: "login", component: ()=>import("../pages/LoginPage.vue"), requireAdmin: false },
]


const router = createRouter({
    history: createWebHashHistory(),
    routes, 
})

router.beforeEach((to) => {
    const token = getToken();
    console.log(token);
    // 验真是否登陆
    if (to.meta.requiresAuth && token == "") {
        // 此路由需要授权，请检查是否已登录
        // 如果没有，则重定向到登录页面
        console.log("need login");
        return {
            path: '/user/login',
            // 保存我们所在的位置，以便以后再来
            query: { redirect: to.fullPath },
        }
    }
    // 验证权限
    // if (to.meta.requireAdmin) {
    //     const role = getRole(getUserId());
    //     if (role != enumValue.permissionAdmin) {
    //         messageWarning("权限不足，不能访问该页面,请登陆对应账户")
    //         return {
    //             path: '/user/login',
    //             // 保存我们所在的位置，以便以后再来
    //             query: { redirect: to.fullPath },
    //         }
    //     }

    // }
})



export default router;